import { computed } from 'vue';
import { useElementSize, useWindowSize } from '@vueuse/core';

// Unlike html/body — clamped to the viewport by base.scss `height: 100%`, so their
// boxes never grow with overflowing content — the Nuxt root container tracks the
// real content height.
const NUXT_ROOT_ELEMENT = '#__nuxt';

/**
 * Whether the document is taller than the viewport, reactive to both window
 * resizes and content size changes.
 */
export function usePageScrollable() {
  const { height: windowHeight } = useWindowSize();
  const { height: contentHeight } = useElementSize(document.querySelector<HTMLElement>(NUXT_ROOT_ELEMENT));

  const isScrollable = computed(() => contentHeight.value > windowHeight.value);

  return { isScrollable };
}
